const listeners: ((msg: string) => void)[] = [];

export function emitWebError(message: string): void {
  for (const cb of listeners) cb(message);
}

export function createWebErrorApi() {
  return {
    onShowError(callback: (message: string) => void): void {
      listeners.push(callback);
    },
    removeShowErrorListener(callback: (message: string) => void): void {
      const i = listeners.indexOf(callback);
      if (i !== -1) listeners.splice(i, 1);
    },
  };
}
